import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-sourcing';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark Inventory: Where To Get Clothes That Sell</title>
        <meta
          name='description'
          content='Learn about 8 different sources that can help you keep your online business in stock!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-sharing-strategy' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-sharing-strategy' />
        <meta property='og:title' content='Poshmark Inventory: Where To Get Clothes That Sell' />
        <meta
          property='og:description'
          content='Learn about 8 different sources that can help you keep your online business in stock!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-09-25T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-09-25T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
